import { formatDate } from 'ha/helpers/hadate';
import {
  PayReqWithConversationParams,
  PayReqCommonParams,
} from 'ha/services/osiris';

import { FormData } from './types';

export const normalizeAnonymous = ({
  dueDate,
  ...formData
}: FormData): PayReqCommonParams => ({
  ...formData,
  amount: (formData.amount * 100).toString(),
  due_date: dueDate ? formatDate('en', 'YYYY-MM-DD', dueDate) : dueDate,
});

export const normalize = (
  formData: FormData,
  conversation: PayReqWithConversationParams,
): PayReqWithConversationParams => ({
  ...conversation,
  ...normalizeAnonymous(formData),
});
